/**
 * Cross-browser `doNotTrack`.
 * Unlike the vanilla property, it returns
 * booleans (or `null` if the browser does not support doNotTrack)
 */
module.exports = function ecosiaDoNotTrack() {
  if ('doNotTrack' in navigator) {
    return navigator.doNotTrack === '1';
  }
  if ('doNotTrack' in window) {
    // old Edge or Safari
    return window.doNotTrack === '1';
  }
  return null;
};
